import { Navigate, useLocation } from "react-router-dom";

const EXACT: Record<string, string> = {
  "/marketplace/listings": "/marketplace/listings",
  "/marketplace/orders": "/marketplace/sales",
  "/marketplace/sellers": "/marketplace/sellers",
  "/flexxi/templates": "/flexxi/templates",
  "/flexxi/plans": "/flexxi/plans",
  "/commerce": "/marketplace",
  "/commerce/marketplace/listings": "/marketplace/listings",
  "/commerce/marketplace/sales": "/marketplace/sales",
  "/commerce/marketplace/sellers": "/marketplace/sellers",
  "/commerce/marketplace/settings": "/marketplace/settings",
  "/commerce/flexxi/templates": "/flexxi/templates",
  "/commerce/flexxi/plans": "/flexxi/plans",
  "/commerce/flexxi/settings": "/flexxi/settings",
};

function resolveLegacyPath(pathname: string): string {
  if (EXACT[pathname]) return EXACT[pathname];
  if (pathname.startsWith("/commerce/flexxi/")) {
    return pathname.replace("/commerce/flexxi/", "/flexxi/");
  }
  if (pathname.startsWith("/commerce/marketplace/")) {
    return pathname.replace("/commerce/marketplace/", "/marketplace/");
  }
  if (pathname.startsWith("/commerce")) return "/marketplace";
  return "/marketplace";
}

/** Preserves old bookmarks under /marketplace/*, /flexxi/*, and /commerce/*. */
export function CommerceLegacyRedirect() {
  const { pathname } = useLocation();
  return <Navigate to={resolveLegacyPath(pathname)} replace />;
}
